// extracted by mini-css-extract-plugin
module.exports = {"content":"GetInStockInfoModal_content__wla11","inputs":"GetInStockInfoModal_inputs__0lFuY"};